import { Provider } from 'react-redux';
import React, { lazy } from 'react';
import {
  QueryClientProvider,
} from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { store } from 'src/store';
import { queryClient } from 'src/lib/queryClient';
import { Loader } from 'src/components/Loader';

const AppThemeLazy = lazy(() => import('src/build/AppTheme'));

export const App: React.FC = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <React.Suspense fallback={<Loader fullSize />}>
          <AppThemeLazy />
        </React.Suspense>
        {/* <ReactQueryDevtools initialIsOpen /> */}
      </QueryClientProvider>
    </Provider>
  );
};
